const SHANGHAI_OFFSET_MS = 8 * 60 * 60 * 1000

export const BEIJING_TIME_ZONE = 'Asia/Shanghai'
export const BEIJING_VARIABLE_DATE_FORMAT = 'beijing'

const BEIJING_FORMAT_SEPARATOR = '|'

/** 运行时把「北京时区」和默认格式拼在一起。存盘仍是 beijing。 */
export function applyBeijingVariableFormat(selected: string | undefined, fallback: string) {
    if (selected !== BEIJING_VARIABLE_DATE_FORMAT) {
        return selected
    }
    return `${BEIJING_VARIABLE_DATE_FORMAT}${BEIJING_FORMAT_SEPARATOR}${fallback}`
}

/** beijing 或 beijing|默认格式。不是北京时区时返回 undefined。 */
export function readBeijingBaseFormat(format: string) {
    if (format === BEIJING_VARIABLE_DATE_FORMAT) {
        return 'yyyy-MM-dd'
    }
    const prefix = `${BEIJING_VARIABLE_DATE_FORMAT}${BEIJING_FORMAT_SEPARATOR}`
    if (!format.startsWith(prefix)) {
        return
    }
    return format.slice(prefix.length) || 'yyyy-MM-dd'
}

export function isBeijingTimeZone(timeZone?: string) {
    return timeZone === BEIJING_TIME_ZONE
}

function shiftToShanghaiWall(instant: number, offsetMinutes: number) {
    return instant + SHANGHAI_OFFSET_MS + offsetMinutes * 60 * 1000
}

/**
 * 返回的 Date 只给本地日历函数读取北京钟面。不要把 getTime() 存进字段。
 */
export function toShanghaiWall(timestamp: number) {
    const offsetAtInstant = new Date(timestamp).getTimezoneOffset()
    const first = shiftToShanghaiWall(timestamp, offsetAtInstant)
    const offsetAtWall = new Date(first).getTimezoneOffset()
    if (offsetAtWall === offsetAtInstant) {
        return new Date(first)
    }
    return new Date(shiftToShanghaiWall(timestamp, offsetAtWall))
}

/** 墙钟上的年月日时分是北京时间，转回真实毫秒 */
export function fromShanghaiWall(wall: Date) {
    return wall.getTime() - SHANGHAI_OFFSET_MS - wall.getTimezoneOffset() * 60 * 1000
}

/** 今天、明天、昨天。选了北京时区时按北京日历取日，不拿本机 0 点再换算。 */
const RELATIVE_DAY_OFFSET: Record<string, number> = {
    TODAY: 0,
    TOMORROW: 1,
    YESTERDAY: -1
}

/**
 * 北京时区下，相对日当天 0 点的真实毫秒。
 * 不是北京时区、或不是这三个变量时返回 undefined。
 */
export function beijingRelativeDayInstant(systemValue: string | undefined, format: string | undefined, now = Date.now()) {
    if (!systemValue || !format || !readBeijingBaseFormat(format)) {
        return
    }
    const offset = RELATIVE_DAY_OFFSET[systemValue]
    if (offset === undefined) {
        return
    }
    const wall = toShanghaiWall(now)
    wall.setDate(wall.getDate() + offset)
    wall.setHours(0, 0, 0, 0)
    return fromShanghaiWall(wall)
}
